import gql from 'graphql-tag';

/**
 * 获取商品详情
 */
export const fetchProductDetailDocument = gql`
  query product($id: ID) {
    product(id: $id) {
      id
      name
      description
      enabled
      productTotalStock
      pointsExchangeInfo {
        id
        exchangeLimit
        allowPurchaseAtOriginalPrice
        exchangeConditionType
        pointExchange {
          points
          cash
          exchangeTotal
        }
      }
      productPurchasePermission {
        id
        productId
        isMembershipPlanPurchase
        membershipPlans {
          id
        }
        guideMembershipPlanId
      }
      reviews {
        items {
          id
          createdAt
          order {
            lines {
              id
              quantity
              productVariant {
                id
                sku
                price
                name
                options {
                  code
                  name
                  group {
                    code
                    name
                  }
                }
                featuredAsset {
                  source
                }
              }
            }
          }
          description
          stars
          reviewImgs
          customerName
          customerNameIsPublic
          customer {
            lastName
            customFields {
              headPortrait
            }
          }
        }
        totalItems
      }
      memberPriceActivityAmount {
        minDiscount
        maxDiscount
        minMemberPriceAmount
        maxMemberPriceAmount
        memberPriceProductVariant {
          memberPriceAmount
          productVariantId
          memberDiscount
          discountType
        }
      }
      optionGroups {
        id
        code
        name
        customFields {
          priority
        }
        options {
          id
          code
          name
          customFields {
            priority
          }
        }
      }
      variants {
        id
        name
        exclusionGroupsTypeName
        isCanPurchase
        pointExchange {
          points
          cash
          exchangeTotal
        }
        customFields {
          virtualTargetType
        }
        virtualTarget {
          ... on Coupon {
            id
            cname: name
            cstate: state
            enable
            createdAt
            updatedAt
            remarks
            type
            preferentialContent {
              preferentialType
              minimum
              discount
              maximumOffer
              includingDiscountProducts
            }
            validityPeriod {
              type
              startTime
              endTime
              numberOfDays
            }
            totalQuantity
            applicableProduct {
              applicableType
              productIds
            }
            whetherRestrictUsers
            memberPlanIds
            introduce
            promotion {
              id
            }
            activityContent
            activityTime
          }
          ... on MembershipPlan {
            id
            name
            state
          }
        }
        options {
          code
          name
          id
          group {
            id
            code
            name
          }
        }
        featuredAsset {
          source
        }
        isThereAnyStock
        price
        sku
      }
      featuredAsset {
        source
      }
      assets {
        id
        width
        height
        name
        preview
        source
        type
      }
      customFields {
        price
        markingPrice
        isVipProduct
        unit
        particulars
        limitType
        limitCount
        productType
        virtualTargetType
        isHiddenCart
        subscriptionPlan {
          id
          periodAndDiscount {
            expireNumberOfPeriod
            discountType
            discountAmount
            recommend
          }
          subscriptionInterval {
            unit
            frequency
          }
        }
        putOnSaleType
        putOnSaleTime
      }
      participatingActivities {
        id
        createdAt
        updatedAt
        endsAt
        couponCode
        perCustomerUsageLimit
        enabled
        customFields {
          activityName
          type
        }
      }
    }
  }
`;

/**
 * 获取商品规格
 */
export const fetchProdcutVariantsDocument = gql`
  query product($id: ID) {
    product(id: $id) {
      id
      productTotalStock
      optionGroups {
        id
        code
        name
        customFields {
          priority
        }
        options {
          id
          code
          name
          customFields {
            priority
          }
        }
      }
      variants {
        id
        name
        exclusionGroupsTypeName
        isCanPurchase
        options {
          id
          code
          name
          group {
            id
            code
            name
          }
        }
        customFields {
          virtualTargetType
        }
        virtualTarget {
          ... on Coupon {
            id
            cname: name
            cstate: state
            enable
            createdAt
            updatedAt
            remarks
            type
            preferentialContent {
              preferentialType
              minimum
              discount
              maximumOffer
              includingDiscountProducts
            }
            validityPeriod {
              type
              startTime
              endTime
              numberOfDays
            }
            totalQuantity
            applicableProduct {
              applicableType
              productIds
            }
            whetherRestrictUsers
            memberPlanIds
            introduce
            promotion {
              id
            }
            activityContent
            activityTime
          }
          ... on MembershipPlan {
            id
            name
            state
          }
        }
        featuredAsset {
          source
        }
        isThereAnyStock
        price
        sku
      }
    }
  }
`;

/**
 * 获取商品列表
 */
export const fetchProductListOptionsDocument = gql`
  query products($options: ProductListOptions) {
    products(options: $options) {
      items {
        id
        name
        enabled
        productTotalStock
        pointsExchangeInfo {
          id
          exchangeLimit
          allowPurchaseAtOriginalPrice
          exchangeConditionType
          pointExchange {
            points
            cash
            exchangeTotal
          }
        }
        productPurchasePermission {
          id
          productId
          isMembershipPlanPurchase
          membershipPlans {
            id
          }
          guideMembershipPlanId
        }
        memberPriceActivityAmount {
          minDiscount
          maxDiscount
          minMemberPriceAmount
          maxMemberPriceAmount
          memberPriceProductVariant {
            memberPriceAmount
            productVariantId
            memberDiscount
            discountType
          }
        }
        featuredAsset {
          source
        }
        customFields {
          price
          markingPrice
          limitType
          limitCount
          putOnSaleType
          putOnSaleTime
          isVipProduct
          isHiddenCart
          virtualTargetType
          productType
        }
        participatingActivities {
          id
          createdAt
          updatedAt
          endsAt
          couponCode
          perCustomerUsageLimit
          enabled
          customFields {
            type
            activityName
          }
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取活动商品列表
 */
export const fetchActiveProductListOptionsDocument = gql`
  query activeProducts(
    $options: ProductListOptions
    $promotionType: PromotionType
    $isExchange: Boolean
  ) {
    activeProducts(options: $options, promotionType: $promotionType, isExchange: $isExchange) {
      items {
        id
        name
        enabled
        productTotalStock
        pointsExchangeInfo {
          id
          exchangeLimit
          allowPurchaseAtOriginalPrice
          exchangeConditionType
          pointExchange {
            points
            cash
            exchangeTotal
          }
        }
        productPurchasePermission {
          id
          productId
          isMembershipPlanPurchase
          membershipPlans {
            id
          }
          guideMembershipPlanId
        }
        memberPriceActivityAmount {
          minDiscount
          maxDiscount
          minMemberPriceAmount
          maxMemberPriceAmount
          memberPriceProductVariant {
            memberPriceAmount
            productVariantId
            memberDiscount
            discountType
          }
        }
        featuredAsset {
          source
        }
        customFields {
          price
          markingPrice
          limitType
          limitCount
          putOnSaleType
          putOnSaleTime
          isVipProduct
          isHiddenCart
          virtualTargetType
        }
        participatingActivities {
          id
          createdAt
          updatedAt
          endsAt
          couponCode
          perCustomerUsageLimit
          enabled
          customFields {
            type
            activityName
          }
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取商品列表 - 自定义排序
 */
export const fetchProductsSortByProductIdsDocument = gql`
  query productsSortByProductIds($options: ProductListOptions) {
    productsSortByProductIds(options: $options) {
      items {
        id
        name
        enabled
        productTotalStock
        pointsExchangeInfo {
          id
          exchangeLimit
          allowPurchaseAtOriginalPrice
          exchangeConditionType
          pointExchange {
            points
            cash
            exchangeTotal
          }
        }
        productPurchasePermission {
          id
          productId
          isMembershipPlanPurchase
          membershipPlans {
            id
          }
          guideMembershipPlanId
        }
        memberPriceActivityAmount {
          minDiscount
          maxDiscount
          minMemberPriceAmount
          maxMemberPriceAmount
          memberPriceProductVariant {
            memberPriceAmount
            productVariantId
            memberDiscount
            discountType
          }
        }
        featuredAsset {
          source
        }
        customFields {
          price
          markingPrice
          limitType
          limitCount
          putOnSaleType
          putOnSaleTime
          isVipProduct
          isHiddenCart
          virtualTargetType
        }
        participatingActivities {
          id
          createdAt
          updatedAt
          endsAt
          couponCode
          perCustomerUsageLimit
          enabled
          customFields {
            type
            activityName
          }
        }
      }
      totalItems
    }
  }
`;

/**
 * 精选配置商品
 */
export const fetchSettingsDocument = gql`
  query settings($keyNames: [SettingKey]) {
    settings(keyNames: $keyNames) {
      id
      createdAt
      updatedAt
      key
      value
    }
  }
`;

/**
 * 商品倒计时活动
 */
export const fetchActivityCountdownByProductDocument = gql`
  query activityCountdownByProduct($productId: ID!) {
    activityCountdownByProduct(productId: $productId) {
      id
      createdAt
      updatedAt
      activityType
      activityId
      name
      countdownTime
      priority
    }
  }
`;
